import Menu from "./menu";
import Search from "./search";
import SearchPage from "./search-page";
import NotFoundSearch from "./notfound-search";
import SidebarLatest from "./sidebar-latest";
import FacetNavCounts from "./facet-nav-counts";
import LoadMore from "./load-more";
import ScrollToTop from "./scroll-to-top";
import TocScrollspy from "./toc-scrollspy";
import "normalize.css";
import "src/scss/index.scss"; /* eslint-disable-line */

(function () {
    Menu.init();
    Search.init();
    SearchPage.init();
    NotFoundSearch.init();
    SidebarLatest.init();
    FacetNavCounts.init();
    ScrollToTop.init();
    TocScrollspy.init();

    // itemSelector includes .ad-unit-grid-span / .ad-unit-feed-span so that
    // Load More batches also carry their mid-feed ad slot across. load-more.ts
    // calls adsbygoogle.push() after insertion to initialise those units.
    new LoadMore({ gridSelector: "#tile-grid", itemSelector: "a.tile, .ad-unit-grid-span", buttonSelector: "#load-more" }).init();
    new LoadMore({ gridSelector: "#feed", itemSelector: "div.card, .ad-unit-feed-span", buttonSelector: "#load-more-feed" }).init();

    window.addEventListener("click", function (event) {
        // Only real user clicks. search-shared.ts's seedLocaleFilter() keeps
        // .click()-ing the hidden Locale checkbox for a few seconds after the
        // search panel first opens, and those synthetic clicks were landing
        // here as "outside" clicks — closing a facet menu the user had just
        // opened.
        if (!event.isTrusted) {
            return;
        }
        Menu.handleOutsideClick(event.target as Node);
        Search.handleOutsideClick(event.target as Node);
    });
})();
